const REQUIRED_SCOPES = ["realtimepayment", "authcapture", "refund"];

export const missingScopes = (scopes: string[]) => {
  return REQUIRED_SCOPES.filter((scope) => !scopes.includes(scope));
};
